import { call, put, takeEvery } from 'redux-saga/effects';
import { END_SERIES_LIST_REQUEST, endSeriesListSuccess, endSeriesListFailure } from '../actions/actions';
import api from '../common/api';
import checkResponse from '../common/checkResponse';

function* handleRequest(action) {
console.log("END_SERIES_LIST_REQUEST 呼ばれた!!!! ");
  try {
    const response = yield call(api, action);
    const payload = yield response.json();

    if(!checkResponse(response, payload)) return;

    if( payload.sc === 0 && payload.errMsg == null ) {
      yield put(endSeriesListSuccess(payload));
    } else {
      yield put(endSeriesListFailure(payload));
    }
  } catch(error) {
    console.log("error ==> ",error);
  }
}

const endSeriesListSaga = [takeEvery(END_SERIES_LIST_REQUEST, handleRequest)];
export default endSeriesListSaga;